<template>
    <div id="expedienteExternalLinkViewer">

        <b-input-group>
            <b-input-group-prepend is-text>
                <span>Liga para el cliente</span>
            </b-input-group-prepend>
            <b-form-input  :value="expedienteURL"  placeholder="Requiere guardado previo" disabled/>
            <b-input-group-append variant="primary">
                <a :href="expedienteURL" target="_blank" class="btn btn-primary">
                    <i class="fa fa-external-link-square"></i>
                </a>
            </b-input-group-append>
        </b-input-group>

        <div class="debug" v-if="debug">
            <pre>
                <code>
                expedienteId: {{expedienteId}}
                server: {{expedienteServer}}
                expedienteHash: {{expedienteHash}}
                </code>
            </pre>
        </div>

    </div>
</template>

<script>
import {apiExpedientesURI} from '@/apiConfig'
export default {
    name: "expedienteExternalLinkViewer",
    props: {
        debug: {
            type: Boolean,
            default: false,
        },
        expedienteId: {
            type: [String, Number],
            required: true,
        },
        expedienteServer: {
            type: String,
            required: true,
            default: apiExpedientesURI,
        },
        expedienteHash: {
            type: String
        },
    },
    computed: {
        expedienteURL(){
            if(this.expedienteHash){
                return `${this.expedienteServer}home/${this.expedienteId}/${this.expedienteHash}`;
            }
        }
    },
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        async loadUp() {
            this.isLoading = true;
            try {
                const response = await this.$http.get(`/api/expedientes/${this.expedienteId}/external-link`);
                if (response.data) {
                    this.$el.innerHTML = response.data;
                }
            } catch (e) {
                console.error(e);
            }
            this.isLoading = false;
        },
    }
};
</script>